// dependencies
import { push } from "yarrr";
import { GenerateProcess } from "redux-process";

// ui
import ui from "./ui";

// actions
import { updateUI } from "Actions/ui";

// selectors
import { getPageName } from "Selectors/ui";
import { getActiveGraph, getGraphsList } from "./selectors";

export const changeUI = (keyPath, value) => (dispatch, getState) => {
	const state = getState();
	const pageName = getPageName(state);
	const newKeyPath = [pageName].concat(keyPath);

	dispatch(updateUI(newKeyPath, value));
};

/**
 * Fetch (or refetch) graph data and redraw.
 */
export const initializeGraph = () => async (dispatch, getState) => {
	const state = getState();
	const activeGraph = getActiveGraph(state);

	if (activeGraph.size === 0) {
		return;
	}

	const request = await dispatch(GenerateProcess(activeGraph.get("processName")));

	if (request && request.succeeded) {
		dispatch(changeUI(["activeGraphData"], request.response));
	}
};

/**
 * Set active item
 */
export const setActiveGraph = (graphURL) => (dispatch) => {
	dispatch(push(`/graphs/${graphURL}/`));
	dispatch(initializeGraph());
};

/**
 * Initialize page.
 */
export const init = (graphWidth) => (dispatch, getState) => {
	// set the initial UI
	let initialUI = ui;
	initialUI = initialUI.set("graphWidth", graphWidth);
	dispatch(changeUI([], initialUI));

	// if no active graph, set the first one
	const state = getState();
	const activeGraph = getActiveGraph(state);

	if (activeGraph.size === 0) {
		const firstGraph = getGraphsList(state).get(0);
		dispatch(setActiveGraph(firstGraph.get("url")));
	}

	dispatch(initializeGraph());
};
